// extracted by mini-css-extract-plugin
module.exports = {"formTitleContainer":"Description_formTitleContainer__1dRN1","formTitle":"Description_formTitle__1l-0g","formItemContainer":"Description_formItemContainer__2s_Vq"};